import { useQuery } from '@tanstack/react-query';
import { getAuditDetails } from 'services/auditService';
import { AuditDetailModel } from 'models';

export function useAuditDetails(storeId: string | null | undefined, auditId: string | null | undefined) {
  return useQuery<AuditDetailModel | null, Error>({
    queryKey: ['audit-details', storeId, auditId],
    queryFn: () => getAuditDetails(storeId!, auditId!),
    enabled: !!storeId && !!auditId
  });
}